/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
/** input type for updating data in table "role_assignment" */
export type Role_Assignment_Set_Input = {
  companyId?: string | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  is_delivery_contact?: boolean | null | undefined;
  is_invoicing_contact?: boolean | null | undefined;
  roleId?: string | null | undefined;
  role_name?: User_Role_Enum | null | undefined;
  updated_at?: string | null | undefined;
  userId?: string | null | undefined;
};

export type User_Role_Enum =
  | 'BUYER_DIRECTOR'
  | 'BUYER_FINANCE'
  | 'BUYER_MANAGER'
  | 'BUYER_OWNER'
  | 'COMPANY_ADMIN'
  | 'STAFF_ADMIN'
  | 'SUPPLIER_OWNER'
  | 'SUPPLIER_SALES_ADMIN'
  | 'SUPPLIER_SALES_REP';

export type UpdateCompanyContactsMutationVariables = Exact<{
  newContactUserIds: Array<string> | string;
  newContactExp: Types.Role_Assignment_Set_Input;
  formerContactUserIds: Array<string> | string;
  formerContactExp: Types.Role_Assignment_Set_Input;
  companyId: string;
}>;


export type UpdateCompanyContactsMutation = { former_contacts_update: Array<{ affected_rows: number } | null> | null, new_contacts_update: Array<{ affected_rows: number } | null> | null };


export const UpdateCompanyContactsDocument = /*#__PURE__*/ gql`
    mutation UpdateCompanyContacts($newContactUserIds: [uuid!]!, $newContactExp: role_assignment_set_input!, $formerContactUserIds: [uuid!]!, $formerContactExp: role_assignment_set_input!, $companyId: uuid!) {
  former_contacts_update: update_role_assignment_many(
    updates: {where: {userId: {_in: $formerContactUserIds}, companyId: {_eq: $companyId}}, _set: $formerContactExp}
  ) {
    affected_rows
  }
  new_contacts_update: update_role_assignment_many(
    updates: {where: {userId: {_in: $newContactUserIds}, companyId: {_eq: $companyId}}, _set: $newContactExp}
  ) {
    affected_rows
  }
}
    `;
export type UpdateCompanyContactsMutationFn = Apollo.MutationFunction<UpdateCompanyContactsMutation, UpdateCompanyContactsMutationVariables>;

/**
 * __useUpdateCompanyContactsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyContactsMutation, { data, loading, error }] = useUpdateCompanyContactsMutation({
 *   variables: {
 *      newContactUserIds: // value for 'newContactUserIds'
 *      newContactExp: // value for 'newContactExp'
 *      formerContactUserIds: // value for 'formerContactUserIds'
 *      formerContactExp: // value for 'formerContactExp'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateCompanyContactsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyContactsMutation, UpdateCompanyContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyContactsMutation, UpdateCompanyContactsMutationVariables>(UpdateCompanyContactsDocument, options);
      }
export type UpdateCompanyContactsMutationHookResult = ReturnType<typeof useUpdateCompanyContactsMutation>;
export type UpdateCompanyContactsMutationResult = Apollo.MutationResult<UpdateCompanyContactsMutation>;
export type UpdateCompanyContactsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyContactsMutation, UpdateCompanyContactsMutationVariables>;